(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ika-header"]) return;
  try {
    
class IkaCartCount extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.revision = 0;
    const options = { signal: this.controller.signal };
    document.addEventListener('shopify:cart:lines-update', (event) => {
      const revision = ++this.revision;
      if (!event.promise) return;
      event.promise.then(({ cart, detail }) => {
        if (revision !== this.revision || !this.isConnected) return;
        const count = cart?.totalQuantity ?? detail?.itemCount;
        if (Number.isInteger(count) && count >= 0) this.renderCount(count);
        else this.refreshCount();
      }).catch(() => {
        if (revision === this.revision && this.isConnected) this.refreshCount();
      });
    }, options);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) this.refreshCount();
    }, options);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.revision++;
  }

  renderCount(count) {
    const output = this.querySelector('[data-ika-cart-count]');
    if (!output) return;
    output.textContent = String(count);
    this.closest('a')?.setAttribute('aria-label', this.dataset.label.replace('__count__', String(count)));
  }

  async refreshCount() {
    const revision = ++this.revision;
    try {
      const response = await fetch(`${this.dataset.cartUrl}.js`, {
        credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (revision === this.revision && this.isConnected && Number.isInteger(cart.item_count) && cart.item_count >= 0) {
        this.renderCount(cart.item_count);
      }
    } catch (_) {}
  }
}

if (!customElements.get('ika-cart-count')) customElements.define('ika-cart-count', IkaCartCount);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ika-hero"] && !Shopify.designMode) return;
  try {
    
const fitPolaroids = (field) => {
 const cards = Array.from(field.querySelectorAll(':scope > .ika-polaroid'));
 const count = cards.length;
 if (!count || !field.clientWidth) return;
 const width = field.clientWidth;
 const height = field.clientHeight;
 let best = { scale: 0, cols: 1, rows: count };
 for (let cols = 1; cols <= count; cols++) {
  const rows = Math.ceil(count / cols);
  const scale = Math.min(width / ((cols - 1) * 260 + 320), height / ((rows - 1) * 330 + 410));
  if (scale > best.scale) best = { scale, cols, rows };
 }
 const baseline = Math.min(width / 580, height / 740);
 const scale = Math.min(best.scale, baseline * Math.min(1, Math.sqrt(4 / count)));
 const layoutWidth = (best.cols - 1) * 260 + 320;
 const layoutHeight = (best.rows - 1) * 330 + 410;
 const offsetX = (width - layoutWidth * scale) / 2;
 const offsetY = (height - layoutHeight * scale) / 2;
 field.dataset.fitted = '';
 cards.forEach((card, index) => {
  const row = Math.floor(index / best.cols);
  const col = index % best.cols;
  const inRow = Math.min(best.cols, count - row * best.cols);
  const rowOffset = (best.cols - inRow) * 130;
  card.style.left = (offsetX + (20 + rowOffset + col * 260) * scale) + 'px';
  card.style.top = (offsetY + (30 + row * 330 + (col % 2) * 12) * scale) + 'px';
  card.style.scale = String(scale);
 });
};
const polaroidObservers = new WeakMap();
const initPolaroids = () => {
 document.querySelectorAll('.ika-polaroids').forEach(field => {
  if (polaroidObservers.has(field)) return;
  const resize = new ResizeObserver(() => fitPolaroids(field));
  const mutations = new MutationObserver(() => fitPolaroids(field));
  resize.observe(field);
  mutations.observe(field, { childList: true });
  polaroidObservers.set(field, { resize, mutations });
  fitPolaroids(field);
 });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPolaroids);
else initPolaroids();
document.addEventListener('shopify:section:load', initPolaroids);
document.addEventListener('shopify:section:unload', event => {
 event.target.querySelectorAll('.ika-polaroids').forEach(field => {
  const observers = polaroidObservers.get(field);
  if (observers) { observers.resize.disconnect(); observers.mutations.disconnect(); polaroidObservers.delete(field); }
 });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
